module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-cars"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cars.length === 0),
      expression: "cars.length === 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('message.text.cars.no_cars')))])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cars.length > 0),
      expression: "cars.length > 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDealer),
      expression: "isDealer"
    }],
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.addingCar),
      expression: "!addingCar"
    }],
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('b-button', {
    attrs: {
      "size": 'large',
      "variant": 'secondary'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addingCar = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus-square"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.add_vehicle')) + "\n          ")], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addingCar),
      expression: "addingCar"
    }],
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('div', {
    staticClass: "og-form"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('message.title.admin.add_new_vehicle')))]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('table', [_c('tr', [_c('td', {
    staticClass: "align-right"
  }, [_c('label', {
    attrs: {
      "for": "new-brand"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.brand')) + ":")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCar.brand),
      expression: "newCar.brand"
    }],
    attrs: {
      "type": "text",
      "id": "new-brand"
    },
    domProps: {
      "value": (_vm.newCar.brand)
    },
    on: {
      "change": function($event) {
        _vm.$v.newCar.brand.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCar, "brand", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newCar.brand.$error),
      expression: "$v.newCar.brand.$error"
    }],
    staticClass: "form-error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.error.brand')))])]), _vm._v(" "), _c('td', {
    staticClass: "align-right"
  }, [_c('label', {
    attrs: {
      "for": "new-model"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.model')) + ":")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCar.model),
      expression: "newCar.model"
    }],
    attrs: {
      "type": "text",
      "id": "new-model"
    },
    domProps: {
      "value": (_vm.newCar.model)
    },
    on: {
      "change": function($event) {
        _vm.$v.newCar.model.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCar, "model", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newCar.model.$error),
      expression: "$v.newCar.model.$error"
    }],
    staticClass: "form-error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.error.model')))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-right"
  }, [_c('label', {
    attrs: {
      "for": "new-year"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.year')) + ":")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCar.year),
      expression: "newCar.year"
    }],
    attrs: {
      "type": "text",
      "id": "new-year"
    },
    domProps: {
      "value": (_vm.newCar.year)
    },
    on: {
      "change": function($event) {
        _vm.$v.newCar.year.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCar, "year", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newCar.year.$error),
      expression: "$v.newCar.year.$error"
    }],
    staticClass: "form-error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.error.year')))])]), _vm._v(" "), _c('td', {
    staticClass: "align-right"
  }, [_c('label', {
    attrs: {
      "for": "new-price"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.price')) + ":")]), _c('br')]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCar.price),
      expression: "newCar.price"
    }],
    attrs: {
      "type": "text",
      "id": "new-price"
    },
    domProps: {
      "value": (_vm.newCar.price)
    },
    on: {
      "change": function($event) {
        _vm.$v.newCar.price.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCar, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newCar.price.$error),
      expression: "$v.newCar.price.$error"
    }],
    staticClass: "form-error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.error.price')))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "new-description"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.description')) + ":")]), _c('br'), _vm._v(" "), _c('quill-editor', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "new-description",
      "options": _vm.quillOptionsDescription
    },
    on: {
      "change": _vm.changeDescription
    },
    model: {
      value: (_vm.newCar.description),
      callback: function($$v) {
        _vm.$set(_vm.newCar, "description", $$v)
      },
      expression: "newCar.description"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newCar.description.$error),
      expression: "$v.newCar.description.$error"
    }],
    staticClass: "form-error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('message.error.description')))])], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" \n\n          "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addingCar = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-circle"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.hide')) + "\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveNewVehicle
    }
  }, [_c('icon', {
    attrs: {
      "name": "check-circle"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('message.button.save')) + "\n          ")], 1)], 1)])], 1), _vm._v(" "), _c('clearfix', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDealer),
      expression: "isDealer"
    }],
    attrs: {
      "bootstrap": true
    }
  }), _vm._v(" "), _vm._l((_vm.cars), function(car) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cars.length > 0),
        expression: "cars.length > 0"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 content og-bg-light"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDealer),
        expression: "isDealer"
      }],
      staticClass: "car-edit-menu"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.status === 'HOT' || car.status === 'AVAILABLE'),
        expression: "car.status === 'HOT' || car.status === 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.title.admin.icons.hot_status_' + car.status)
      },
      on: {
        "click": function($event) {
          _vm.saveStatus(car.id, (car.status === 'HOT' ? 'AVAILABLE' : 'HOT'))
        }
      }
    }, [_c('icon', {
      class: 'is-enabled-' + (car.status === 'HOT'),
      attrs: {
        "name": "fire"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.status === 'HOT' || car.status === 'AVAILABLE'),
        expression: "car.status === 'HOT' || car.status === 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.title.admin.icons.hide')
      },
      on: {
        "click": function($event) {
          _vm.saveStatus(car.id, 'HIDDEN')
        }
      }
    }, [_c('icon', {
      staticClass: "is-enabled-true",
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.status !== 'HOT' && car.status !== 'AVAILABLE'),
        expression: "car.status !== 'HOT' && car.status !== 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.title.admin.icons.make_available')
      },
      on: {
        "click": function($event) {
          _vm.saveStatus(car.id, 'AVAILABLE')
        }
      }
    }, [_c('icon', {
      staticClass: "is-enabled-false",
      attrs: {
        "name": "eye-slash"
      }
    })], 1), _vm._v(" "), _c('span', {
      attrs: {
        "title": _vm.$t('message.title.admin.icons.update_photos')
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'CarPhotos',
            params: {
              id: car.id
            }
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "camera-retro"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.status !== 'SOLD'),
        expression: "car.status !== 'SOLD'"
      }],
      attrs: {
        "title": _vm.$t('message.title.admin.icons.sell')
      },
      on: {
        "click": function($event) {
          _vm.saveStatus(car.id, 'SOLD')
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "money"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.status !== 'DELETED'),
        expression: "car.status !== 'DELETED'"
      }],
      attrs: {
        "title": _vm.$t('message.title.admin.icons.delete')
      },
      on: {
        "click": function($event) {
          _vm.saveStatus(car.id, 'DELETED')
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDealer),
        expression: "isDealer"
      }],
      staticClass: "car-edit-menu",
      staticStyle: {
        "clear": "right"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('message.title.admin.rec_status')) + ": \n          "), _c('span', {
      class: 'status-' + car.status
    }, [_vm._v(_vm._s(_vm.$t('message.status.' + car.status)))])]), _vm._v(" "), _c('h4', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Car',
          params: {
            id: car.id
          }
        }
      }
    }, [_vm._v(_vm._s(car.brand) + " " + _vm._s(car.model) + " (" + _vm._s(car.year) + ")")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.photos.length > 0),
        expression: "car.photos.length > 0"
      }],
      staticClass: "car-photo",
      style: ({
        backgroundImage: 'url(\'' + _vm.$t(_vm.imageBase, {
          car_id: car.id,
          file_name: _vm.getPhotoFileName(car.photos)
        }) + '\')',
        width: '300px',
        height: '200px'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "car-description",
      domProps: {
        "innerHTML": _vm._s(car.description)
      }
    })]), _vm._v(" "), _c('clearfix', {
      attrs: {
        "wide": true
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cars.length > 0),
      expression: "cars.length > 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1560906e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/car/CarList.vue
// module id = 1199
// module chunks = 1